const defaults = {
    container: '.js-accordion-collapse',
    toggleButton: '.js-collapse-button',
    openState: false,
    scrollOnLoad: true
};

class Accordion {
    constructor(option) {
        this.options = Object.assign({}, defaults, option);
        this.setupToggleEvent();
        if (this.options.scrollOnLoad) {
            window.addEventListener('load', () => this.checkHashAndOpenAccordion());
        }
    }

    setupToggleEvent() {
        const accordionCollapseContainer = document.querySelectorAll(this.options.container);

        accordionCollapseContainer.forEach(container => {
            const toggleButton = container.querySelector(this.options.toggleButton);
            const accordionLinks = container.querySelectorAll('.accordion-summary');

            toggleButton.addEventListener('click', evt => {
                evt.preventDefault();
                toggleButton.blur();
                this.toggleAllItems(accordionLinks, this.options.openState);
                this.options.openState = !this.options.openState;
                this.toggleButtonText(toggleButton, this.options.openState);
            });

            accordionLinks.forEach(link => {
                link.addEventListener('mouseup', () => {
                    const sanitizedText = this.sanitizeText(link.innerText);
                    window.location.hash = sanitizedText;
                });
            });
        });
    }

    sanitizeText(text) {
        return text.trim().replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '');
    }

    toggleAllItems(links, state) {
        links.forEach(link => {
            const targetId = link.getAttribute('data-bs-target');
            const target = document.querySelector(targetId);
            if (state) {
                if (target.classList.contains('show')) {
                    target.classList.remove('show');
                }
            } else {
                if (!target.classList.contains('show')) {
                    target.classList.add('show');
                }
            }
        });
    }

    toggleItem(link) {
        const targetId = link.getAttribute('data-bs-target');
        const target = document.querySelector(targetId);
        if (target.classList.contains('show')) {
            target.classList.remove('show');
        } else {
            target.classList.add('show');
        }
    }

    toggleButtonText(button, state) {
        const closeText = button.dataset.bsClose || 'Fold all in';
        const openText = button.dataset.bsOpen || 'Fold all out';
        button.innerHTML = state ? closeText : openText;
    }

    checkHashAndOpenAccordion() {
        const hash = window.location.hash.replace('#', '');
        const targetLink = Array.from(document.querySelectorAll('.accordion-summary')).find(element =>
            this.sanitizeText(element.innerText) === hash);
        if (targetLink) {
            this.toggleItem(targetLink);
            targetLink.classList.remove('collapsed');
            targetLink.scrollIntoView(true);
        }
    }
}

const init = (option) => {
    new Accordion(option);
};

export default { init };
